import { components } from 'react-select'

const Helper = {
  dateOverlaps: function (startDate1, startDate2, endDate1, endDate2) {
    return (
      (startDate1 >= endDate1 && startDate1 <= endDate2) ||
      (startDate2 >= endDate1 && startDate2 <= endDate2) ||
      (startDate1 <= endDate1 && startDate2 >= endDate2)
    )
  },

  deparam: function (params, coerce) {
    var obj = {},
      coerce_types = { true: !0, false: !1, null: null }

    // Iterate over all name=value pairs.
    jQuery.each(params.replace(/\+/g, ' ').split('&'), function (j, v) {
      var param = v.split('='),
        key = decodeURIComponent(param[0]),
        val,
        cur = obj,
        i = 0,
        // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
        // into its component parts.
        keys = key.split(']['),
        keys_last = keys.length - 1

      // If the first keys part contains [ and the last ends with ], then []
      // are correctly balanced.
      if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
        // Remove the trailing ] from the last keys part.
        keys[keys_last] = keys[keys_last].replace(/\]$/, '')

        // Split first keys part into two parts on the [ and add them back onto
        // the beginning of the keys array.
        keys = keys.shift().split('[').concat(keys)

        keys_last = keys.length - 1
      } else {
        // Basic 'foo' style key.
        keys_last = 0
      }

      // Are we dealing with a name=value pair, or just a name?
      if (param.length === 2) {
        val = decodeURIComponent(param[1])

        // Coerce values.
        if (coerce) {
          val =
            val && !isNaN(val)
              ? +val // number
              : val === 'undefined'
              ? undefined // undefined
              : coerce_types[val] !== undefined
              ? coerce_types[val] // true, false, null
              : val // string
        }

        if (keys_last) {
          // Complex key, build deep object structure based on a few rules:
          // * The 'cur' pointer starts at the object top-level.
          // * [] = array push (n is set to array length), [n] = array if n is
          //   numeric, otherwise object.
          // * If at the last keys part, set the value.
          // * For each keys part, if the current level is undefined create an
          //   object or array based on the type of the next keys part.
          // * Move the 'cur' pointer to the next level.
          // * Rinse & repeat.
          for (; i <= keys_last; i++) {
            key = keys[i] === '' ? cur.length : keys[i]
            cur = cur[key] = i < keys_last ? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : []) : val
          }
        } else {
          // Simple key, even simpler rules, since only scalars and shallow
          // arrays are allowed.

          if (Array.isArray(obj[key])) {
            // val is already an array, so push on the next value.
            obj[key].push(val)
          } else if (obj[key] !== undefined) {
            // val isn't an array, but since a second value has been specified,
            // convert val into an array.
            obj[key] = [obj[key], val]
          } else {
            // val is a scalar.
            obj[key] = val
          }
        }
      } else if (key) {
        // No value was defined, so set something meaningful.
        obj[key] = coerce ? undefined : ''
      }
    })

    return obj
  },

  mouseWheelBlocks: function () {
    document.querySelectorAll('.scrollable').forEach(function (element) {
      if (element.dataset.mouseWheelBlocksBinded) return true

      element.addEventListener(
        'mousewheel',
        function (ev) {
          var $this = $(element),
            scrollTop = element.scrollTop,
            scrollHeight = element.scrollHeight,
            height = $this.innerHeight(),
            delta = ev.wheelDelta,
            up = delta > 0

          var prevent = function () {
            ev.stopPropagation()
            ev.preventDefault()
            ev.returnValue = false
            return false
          }

          if (!up && -delta > scrollHeight - height - scrollTop) {
            // Scrolling down, but this will take us past the bottom.
            $this.scrollTop(scrollHeight)
            return prevent()
          } else if (up && delta > scrollTop) {
            // Scrolling up, but this will take us past the top.
            $this.scrollTop(0)
            return prevent()
          }
        },
        { passive: false }
      )

      element.dataset.mouseWheelBlocksBinded = true
    })
  },
  capitalize: function (text) {
    return text.charAt(0).toUpperCase() + text.slice(1)
  },
  uuid: function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  },
  period: function (name) {
    let start, end
    switch (name) {
      case 'today':
        start = moment()
        end = moment()
        break
      case 'yesterday':
        start = moment().add(-1, 'day')
        end = moment().add(-1, 'day')
        break
      case 'tomorrow':
        start = moment().add(1, 'day')
        end = moment().add(1, 'day')
        break
      case 'this_week':
        start = moment().startOf('isoWeek')
        end = moment().endOf('isoWeek')
        break
      case 'last_week':
        start = moment().startOf('isoWeek').add(-7, 'days')
        end = moment().startOf('isoWeek').add(-1, 'days')
        break
      case 'next_week':
        start = moment().startOf('isoWeek').add(7, 'days')
        end = moment().endOf('isoWeek').add(7, 'days')
        break
      case 'this_month':
        start = moment().startOf('month')
        end = moment().endOf('month')
        break
      case 'last_month':
        start = moment().startOf('month').add(-1, 'days').startOf('month')
        end = moment().startOf('month').add(-1, 'days')
        break
      case 'next_month':
        start = moment().startOf('month').add(1, 'month')
        end = moment().startOf('month').add(1, 'month').endOf('month')
        break
      case 'last_30d':
        start = moment().add(-30, 'days')
        end = moment().add(-1, 'days')
        break
      case 'last_90d':
        start = moment().add(-90, 'days')
        end = moment().add(-1, 'days')
        break
      case 'next_30d':
        start = moment()
        end = moment().add(29, 'days')
        break
      case 'next_90d':
        start = moment()
        end = moment().add(89, 'days')
        break
      case 'last_3m':
        start = moment().startOf('month').add(-3, 'months')
        end = moment().startOf('month').add(-1, 'days')
        break
      case 'next_3m':
        start = moment().startOf('month').add(1, 'month')
        end = moment().startOf('month').add(3, 'month').endOf('month')
        break
      case 'last_6m':
        start = moment().startOf('month').add(-6, 'months')
        end = moment().startOf('month').add(-1, 'days')
        break
      case 'next_6m':
        start = moment().startOf('month').add(1, 'month')
        end = moment().startOf('month').add(6, 'month').endOf('month')
        break
      case 'last_12m':
        start = moment().startOf('month').add(-12, 'months')
        end = moment().startOf('month').add(-1, 'days')
        break
      case 'next_12m':
        start = moment().startOf('month').add(1, 'month')
        end = moment().startOf('month').add(12, 'month').endOf('month')
        break
      case 'this_year':
        start = moment().startOf('year')
        end = moment().endOf('year')
        break
      case 'last_year':
        start = moment().startOf('year').add(-12, 'months')
        end = moment().startOf('year').add(-1, 'days')
        break
      case 'next_year':
        start = moment().startOf('year').add(12, 'months')
        end = moment().endOf('year').add(12, 'months')
        break
    }

    return [start, end]
  },
  reactSelectStyles: function () {
    return {
      container: (provided, state) => ({
        ...provided,
        boxShadow: 'none'
      }),
      control: (provided, state) => ({
        ...provided,
        borderRadius: '2px',
        '&:hover': {
          borderColor: '#999'
        }
      }),
      placeholder: (provided, state) => ({
        ...provided,
        marginLeft: '16px'
      }),
      input: (provided, state) => ({
        ...provided,
        marginLeft: '16px'
      }),
      valueContainer: (provided, state) => ({
        ...provided,
        padding: '2px'
      }),
      singleValue: (provided, state) => ({
        ...provided,
        marginLeft: '16px'
      }),
      multiValue: (provided, state) => ({
        ...provided,
        height: '30px',
        alignItems: 'center'
      }),
      multiValueRemove: (provided, state) => ({
        ...provided,
        alignSelf: 'stretch'
      }),
      menu: (provided, state) => ({
        ...provided,
        borderRadius: '2px'
      })
    }
  },
  reactSelectTheme: function (theme) {
    return {
      ...theme,
      colors: {
        ...theme.colors,
        primary: '#999',
        primary75: '#d5dbe4',
        primary50: '#d5dbe4',
        primary25: '#d5dbe4'
      }
    }
  },
  reactDropdownIndicator: function ({ children, ...props }) {
    return (
      <components.DropdownIndicator {...props}>
        <i className="fa-light fa-angle-down"></i>
      </components.DropdownIndicator>
    )
  },
  cleanObject: function(object) {
    if (!object) return object

    Object
        .entries(object)
        .forEach(([k, v]) => {
            if (v && typeof v === 'object')
                this.cleanObject(v);
            if (v &&
                typeof v === 'object' &&
                !Object.keys(v).length ||
                v === null ||
                v === undefined ||
                v.length === 0
            ) {
                if (Array.isArray(object))
                    object.splice(k, 1);
                else if (!(v instanceof Date))
                    delete object[k];
            }
        });
    return object;
  }
}

export default Helper
